module.exports = __webpack_public_path__ + "assets/ba4ddffe76fc1b66f4ee1b6277d9c5b8.png";